export default "__VITE_PUBLIC_ASSET__50934adb__"